<template>
    <tr>
        <td><a href="javascript:void(0)">
                <svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512">
                    <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                    <path
                        d="M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" />
                </svg>
            </a>
        </td>
        <td class="p-5 font-bold underline id-color-menu-edit whitespace-nowrap" @click="getServingAmountScale">
            <a :href="route('ingredients-edit', { id: ingredient.id })" target="_blank">
                {{ ingredient.name }}</a>
        </td>

        <td>
            <div class="flex items-center">
                <div v-if="custom_sizing_recipe_amount != '' && custom_sizing_recipe_amount != null && custom_sizing_recipe_amount != 0 && custom_sizing_recipe_amount_uom != '' && custom_sizing_recipe_amount_uom != null"
                    class="flex items-center p-5">

                    <div v-if="isCustomUnit" class="p-5 min-w-[246px]">
                        <div class=" text-center  p-1 pb-0">

                            <a href="javascript:void(0)" :title="customUnitTooltip()">
                            {{ removePipeCharacters(recipe_amount_uom) }}
                            </a>

                            <span
                                class="text-xs font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer ml-1"
                                @click="resetCustomUnit">[X]</span>
                        </div>
                        <div class="text-center">
                            <span>{{ convertToFix(custom_sizing_main_recipe_amount) }} {{ recipe_amount_custom_uom }}
                            </span>
                            <!-- <span>{{ convertToFix(recipe_amount) }} {{ recipe_amount_custom_uom }} </span> -->
                            <span> + </span>
                            <span class=""> {{ convertToFix(custom_sizing_recipe_amount) }} {{
                                getUmoName(custom_sizing_recipe_amount_uom) }}</span>
                            <a class="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer ml-2"
                                @click="openUomModel()">[+]</a>
                        </div>
                    </div>

                    <div v-else class="p-5 min-w-[246px]">
                        {{ convertToFix(custom_sizing_main_recipe_amount) }} {{ recipe_amount_uom }} +
                        {{ convertToFix(custom_sizing_recipe_amount) }} {{ custom_sizing_recipe_amount_uom }}
                        <a class="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer ml-2"
                            @click="openUomModel()">[+]</a>
                    </div>
                </div>
                <div v-else class="flex items-end p-5">
                
                    <div class="cursor-pointer  shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24 h-10 bg-[#ccc] flex justify-center items-center mr-4"
                        v-if="is_frection" @click="$emit('toggleFrection')">{{
                            decimalToFractionNew(recipe_amount) }}</div>
                    <input v-if="!is_frection" @input="convertToDecimal('recipe_amount_fractions', 'recipe_amount')"
                        type="text"
                        class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4"
                        required="" v-model="recipe_amount_fractions">
                    <input @change="handleChangeRecipeAmount" type="hidden" min="0" step="any"
                        class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4"
                        model="recipe_amount" required="" :value="convertToFix(this.recipe_amount)"
                        @input="this.recipe_amount = $event.target.value">

                    <div>
                        <div class="flex items-end">
                            <div>
                                <div class="flex items-center p-1 pb-0" v-if="isCustomUnit">
                                    <a href="javascript:void(0)" :title="customUnitTooltip()">
                                    {{ removePipeCharacters(recipe_amount_uom) }}
                                    </a>
                                    <div v-if="isCustomUnit"
                                        class="text-xs font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer ml-1"
                                        @click="resetCustomUnit">[X]</div>
                                </div>
                                <uom-dropdown v-if="!isCustomUnit" :options="availableUoms" :cuom="ingredient.cuom"
                                :preferred_product_information="preferred_product_information"
                                    v-model="recipe_amount_uom" />

                                <uom-dropdown v-if="isCustomUnit" class="mt-3" :options="availableCustomUoms" 
                                :preferred_product_information="preferred_product_information" :selectedCustomUnitOfMeasurement="selectedCustomUnitOfMeasurement"
                                    v-model="recipe_amount_custom_uom" />
                            </div>
                            <a class="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer mb-2"
                                @click="openUomModel()">[+]</a>
                        </div>
                    </div>
                </div>
            </div>

        </td>
        <td>
            <div v-if="recipe_amount !== null && recipe_portion > 0" class="flex items-end p-5">
                <div class="cursor-pointer  shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-24 h-10 bg-[#ccc] flex justify-center items-center mr-4"
                    v-if="is_frection" @click="$emit('toggleFrection')">{{
                        decimalToFractionNew(serving_amount) }} </div>

                <input v-if="!is_frection" @input="convertToDecimal('serving_amount_fractions', 'serving_amount')"
                    type="text"
                    class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4"
                    required="" v-model="serving_amount_fractions">

                <input @change="handleChangeServingAmount" :value="convertToFix(this.serving_amount)"
                    @input="this.serving_amount = $event.target.value" type="hidden" min="0" step="any"
                    class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4"
                    model="serving_amount" required="">
                <div>
                    <div class="flex items-center p-1 pb-0" v-if="isCustomUnit">
                        <a href="javascript:void(0)" :title="customUnitTooltip()">
                        {{ removePipeCharacters(recipe_amount_uom) }}</a>
                        <div v-if="isCustomUnit"
                            class="text-xs font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer ml-1"
                            @click="resetCustomUnit">[X]</div>
                    </div>
                    <uom-dropdown v-if="!isCustomUnit" :options="availableUoms" :cuom="ingredient.cuom"
                     :preferred_product_information="preferred_product_information"
                        v-model="serving_amount_uom" />
                    <uom-dropdown v-if="isCustomUnit" class="mt-3" :options="availableCustomUoms" :preferred_product_information="preferred_product_information"
                    :selectedCustomUnitOfMeasurement="selectedCustomUnitOfMeasurement"
                        v-model="serving_amount_custom_uom" />
                </div>
            </div>
        </td>
        <td>

            <usda-component @changeComponent="handleChangeComponentValue" key="component_mma" v-model="component_mma"
                :scale="component_scale" :init-value="preferred_product_information.component_mma"
                :hide-values="serving_amount === null" :recipe-portion="recipe_portion"
                :check-override="componentOverrideData.optional_component_mma" :is_frection="is_frection"
                :isNearestQuarter="true"
                @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_wgr" :scale="component_scale"
                :init-value="preferred_product_information.component_wgr" :hide-values="serving_amount === null"
                :isNearestQuarter="true"
                :recipe-portion="recipe_portion" :check-override="componentOverrideData.optional_component_wgr"
                :is_frection="is_frection" @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_fru" :scale="component_scale"
                :init-value="preferred_product_information.component_fru" :hide-values="serving_amount === null"
                :recipe-portion="recipe_portion" :check-override="componentOverrideData.optional_component_fru"
                :is_frection="is_frection" @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_mlk" :scale="component_scale"
                 :init-value="preferred_product_information.component_mlk"
                :hide-values="serving_amount === null" :recipe-portion="recipe_portion"
                :check-override="componentOverrideData.optional_component_mlk" :is_frection="is_frection"
                @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_veg" :scale="component_scale"
                :init-value="preferred_product_information.component_veg" :hide-values="serving_amount === null"
                :recipe-portion="recipe_portion" :check-override="componentOverrideData.optional_component_veg"
                :is_frection="is_frection" @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_dg" :scale="component_scale"
                :init-value="preferred_product_information.component_dg" :hide-values="serving_amount === null"
                :recipe-portion="recipe_portion" :check-override="componentOverrideData.optional_component_dg"
                :is_frection="is_frection" @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_ro" :scale="component_scale"
                :init-value="preferred_product_information.component_ro" :hide-values="serving_amount === null"
                :recipe-portion="recipe_portion" :check-override="componentOverrideData.optional_component_ro"
                :is_frection="is_frection" @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_leg" :scale="component_scale"
                :init-value="preferred_product_information.component_leg" :hide-values="serving_amount === null"
                :recipe-portion="recipe_portion" :check-override="componentOverrideData.optional_component_leg"
                :is_frection="is_frection" @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_star" :scale="component_scale"
                :init-value="preferred_product_information.component_star" :hide-values="serving_amount === null"
                :recipe-portion="recipe_portion" :check-override="componentOverrideData.optional_component_star"
                :is_frection="is_frection" @toggleFrection="toggleFrection()" />
        </td>
        <td>
            <usda-component @changeComponent="handleChangeComponentValue" key="component_other" :scale="component_scale"
                :init-value="preferred_product_information.component_other" :hide-values="serving_amount === null"
                :recipe-portion="recipe_portion" :check-override="componentOverrideData.optional_component_other"
                :is_frection="is_frection" @toggleFrection="toggleFrection()" />
        </td>

        <td class="px-6 py-4 whitespace-nowrap  id-color text-xl  font-extrabold">
            <button v-if="recipe.is_tenant_admin" type="button" @click="showOptionalComponentsMethod">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z"
                        clip-rule="evenodd" />
                </svg>
            </button>
            <button v-if="recipe.is_tenant_admin" type="button" @click="onIngredientDeleteMethod" class="pl-2">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd"
                        d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                        clip-rule="evenodd" />
                </svg>
            </button>
        </td>

    </tr>

    <optional-components v-if="show_optional_components" @hideOptionalComponents="hideOptionalComponentsMethod"
        :componentOverrideData="componentOverrideData" @updateOptionalComponents="updateOptionalComponents" />

    <!-- allow user to enter multiple units of measure for ingredients modal -->
    <jet-dialog-modal :show="multipleUnitsOfMeasureModel" @close="multipleUnitsOfMeasureModel = false" :maxWidth="'xl'">
        <template #title>
            <div class="flex justify-center items-center border-b border-black/10 pb-3">
                Custom Sizing
            </div>
        </template>

        <template #content>
            <div v-if="isCustomUnit">{{ removePipeCharacters(recipe_amount_uom) }}</div>
            <div class="md:flex items-center justify-center">
                <div class="flex items-center p-5">
                    <input @change="handleChangeRecipeAmount" type="text"
                        class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4"
                        :value="convertToFix(this.in_model_custom_sizing_main_recipe_amount)"
                        @input="this.in_model_custom_sizing_main_recipe_amount = $event.target.value">
                    <div>
                        <uom-dropdown v-if="isCustomUnit" :options="availableUnitGroups" v-model="recipe_amount_custom_uom"
                        :preferred_product_information="preferred_product_information" :selectedCustomUnitOfMeasurement="selectedCustomUnitOfMeasurement"
                            @multipleUomForIngredients="multipleUomForIngredients" />
                        <uom-dropdown v-else :options="availableUnitGroups" v-model="recipe_amount_uom"
                        :preferred_product_information="preferred_product_information"
                            @multipleUomForIngredients="multipleUomForIngredients" />
                    </div>
                </div>

                +

                <div class="flex items-center p-5">

                    <input @change="handleChangeRecipeAmount" type="text"
                        class="shadow focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md w-18-input mr-4"
                        model="in_model_custom_sizing_recipe_amount" required=""
                        :value="this.in_model_custom_sizing_recipe_amount"
                        @input="this.in_model_custom_sizing_recipe_amount = $event.target.value">
                    <div>
                        <uom-dropdown :options="availableUomsforCustomSizing"
                            v-model="in_model_custom_sizing_recipe_amount_uom" :isCustomUnit="isCustomUnit"
                            :preferred_product_information="preferred_product_information" 
:selectedCustomUnitOfMeasurement="selectedCustomUnitOfMeasurement"
                            :cuoms="ingredient.cuom" />
                    </div>
                </div>
            </div>
        </template>

        <template #footer>
            <!-- <jet-secondary-button class="ml-4">SAVE</jet-secondary-button> -->

            <jet-secondary-button @click="saveCustomSizing">Save</jet-secondary-button>
        </template>
    </jet-dialog-modal>
</template>



<script>
import UomDropdown from "@/Pages/Recipes/Partials/UomDropdown";
import UsdaComponent from "@/Pages/Recipes/Partials/UsdaComponent";
import OptionalComponents from "@/Pages/Recipes/Partials/OptionalComponents";
import JetDialogModal from '@/Jetstream/DialogModal';
import JetButton from "@/Jetstream/Button";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";

export default {
    components: { UsdaComponent, UomDropdown, OptionalComponents, JetDialogModal, JetButton, JetSecondaryButton },
    props: [
        'ingredient',
        'recipe_portion',
        'recipe',
        'recipe_category',
        'is_frection'
    ],
    name: "RecipeIngredients",
    mounted() {
        console.log('recipe_amount_custom_uom', this.recipe_amount_custom_uom)
        // the default UoM is determined based off of the
        // measurement serving information


        if (this.ingredient.optional_component_mma !== null ||
            this.ingredient.optional_component_wgr !== null ||
            this.ingredient.optional_component_fru !== null ||
            this.ingredient.optional_component_mlk !== null ||
            this.ingredient.optional_component_veg !== null ||
            this.ingredient.optional_component_dg !== null ||
            this.ingredient.optional_component_ro !== null ||
            this.ingredient.optional_component_leg !== null ||
            this.ingredient.optional_component_star !== null ||
            this.ingredient.optional_component_other !== null) {
            this.show_optional_components = true;
        }


        //check if it is edit page to check saved data in place of base data
        if (this.ingredient.recipe_ingredient_edit === undefined) {
            this.recipe_amount_uom = this.defaultUom
            this.serving_amount_uom = this.defaultUom
            this.serving_amount = this.getBaseServingAmount()
        }

        // console.log("this.cuoms", this.cuoms);
        this.cuoms = this.ingredient.preferred_product_information.cuom;

        this.isCustomUnit = this.$helpers.uomType(this.recipe_amount_uom) === 'Custom';

    },

    data() {
        return {

            show_optional_components: false,

            debounceTimeout: null,

            cuoms: [],

            componentOverrideData: {
                'optional_component_mma': this.$helpers.nearestValue(this.ingredient.optional_component_mma, true),
                'optional_component_wgr': this.$helpers.nearestValue(this.ingredient.optional_component_wgr, true),
                'optional_component_fru': this.$helpers.nearestValue(this.ingredient.optional_component_fru),
                'optional_component_mlk': this.$helpers.nearestValue(this.ingredient.optional_component_mlk),
                'optional_component_veg': this.$helpers.nearestValue(this.ingredient.optional_component_veg),
                'optional_component_dg': this.$helpers.nearestValue(this.ingredient.optional_component_dg),
                'optional_component_ro': this.$helpers.nearestValue(this.ingredient.optional_component_ro),
                'optional_component_leg': this.$helpers.nearestValue(this.ingredient.optional_component_leg),
                'optional_component_star': this.$helpers.nearestValue(this.ingredient.optional_component_star),
                'optional_component_other': this.$helpers.nearestValue(this.ingredient.optional_component_other),
            },


            recipe_amount: this.ingredient.recipe_amount,
            recipe_amount_fractions: this.ingredient.recipe_amount_fractions,
            // recipe_amount: this.convertToFix(this.ingredient.recipe_amount),
            recipe_amount_uom: this.ingredient.recipe_amount_uom,
            serving_amount: this.ingredient.serving_amount,
            serving_amount_fractions: this.ingredient.serving_amount_fractions,
            //serving_amount_original: null,
            serving_amount_uom: this.ingredient.serving_amount_uom,
            component_mma: this.ingredient.component_mma,
            component_wgr: this.ingredient.component_wgr,
            component_fru: this.ingredient.component_fru,
            component_mlk: this.ingredient.component_mlk,
            component_veg: this.ingredient.component_veg,
            component_dg: this.ingredient.component_dg,
            component_ro: this.ingredient.component_ro,
            component_leg: this.ingredient.component_leg,
            component_star: this.ingredient.component_star,
            component_other: this.ingredient.component_other,
            preferred_product_information: this.ingredient.preferred_product_information,
            isCustomUnit: false,
            recipe_amount_custom_uom: this.ingredient.recipe_amount_custom_uom,
            serving_amount_custom_uom: this.ingredient.serving_amount_custom_uom,
            isMounted: false,
            multipleUnitsOfMeasureModel: false,
            availableUomsforCustomSizing: [],
            custom_sizing_recipe_amount: this.ingredient.custom_sizing_recipe_amount,
            custom_sizing_recipe_amount_uom: this.ingredient.custom_sizing_recipe_amount_uom,

            custom_sizing_main_recipe_amount: this.ingredient.custom_sizing_main_recipe_amount,



            in_model_custom_sizing_main_recipe_amount: '',

            in_model_custom_sizing_recipe_amount: '',
            in_model_custom_sizing_recipe_amount_uom: '',

            in_model_recipe_amount: '',
            in_model_recipe_amount_uom: '',
            // in_model_recipe_amount : '',
            availableUnitGroups: [],

        };
    },


    methods: {

        getCustomUnitOfMeasurement(desc) {
            return this.cuoms.find((cuom) => cuom.description1 === desc);
        },

        toggleFrection() {
            this.$emit('toggleFrection');
        },

        isConvertOrNot(value) {
            // console.log("is convert? value", typeof value, value);
            // if (value === null || value === '') {
            //     return true;
            // }

            // // Convert the value to a number
            // const fractionRegex = /^\d*\s?\d+\/\d+$/;

            // // Check if the value matches the fraction format
            // if (fractionRegex.test(value)) {
            //     return true;
            // }

            // For all other cases, return false
            return false;
        },

        convertToDecimal(fractions, toField) {
            
            // console.log("fraction", fraction, this[fractions], fractions);
            // Regular expression to handle whole numbers, fractions like 1/2, and mixed numbers like 3 1/2

            clearTimeout(this.debounceTimeout);
            let $this = this;
            // const fraction = $this[fractions].trim();
            const fraction = this[fractions]?.trim() || "";

            this.debounceTimeout = setTimeout(() => {
                console.log('debounceTimeout', fraction);
                $this[toField] = $this.getConvertToDecimal(fraction);
                if (toField == 'recipe_amount') {
                    $this.handleChangeRecipeAmount();
                }
                if (toField == 'serving_amount') {
                    $this.handleChangeServingAmount();
                }
            }, 1000);

        },

        getConvertToDecimal(fractions) {
            // console.log('frections', fractions, typeof fractions)
            if (fractions == '' || typeof fractions == null) {
                return fractions;
            }

            if (typeof fractions != 'string') {
                fractions = String(fractions);
            }

            console.log("getConvertToDecimal first ", fractions, typeof fractions);

            const regex = /^(\d+)?\s*(\d+)?\/?(\d+)?$/;
            const match = fractions.match(regex);
            let returnVal = fractions;
            if (match) {
                const wholeNumber = parseFloat(match[1]) || 0;
                const numerator = parseFloat(match[2]) || 0;
                const denominator = parseFloat(match[3]) || 1; // Avoid division by zero

                // Calculate the decimal value
                console.log("fraction if ", wholeNumber, numerator, denominator);
                if (numerator > 0) {
                    returnVal = wholeNumber + (numerator / denominator);
                } else {
                    returnVal = wholeNumber / denominator;
                }
            }
            console.log("getConvertToDecimal last ", returnVal, fractions);
            return returnVal;
        },

        roundToNearestQuarter(num) {
            return Math.round(num * 4) / 4;
        },

        decimalToFractionNew(decimal) {
            decimal = this.roundToNearestQuarter(decimal);
            const integerPart = Math.floor(decimal);
            const fractionalPart = decimal - integerPart;

            if (fractionalPart === 0) {
                return integerPart.toString(); // Return only the integer part if there's no fraction
            }

            // Convert the fractional part to a fraction
            const tolerance = 1.0E-6;  // Tolerance for floating-point precision
            let numerator = 1;
            let denominator = 1;
            let fraction = fractionalPart;

            while (Math.abs(fraction - Math.round(fraction)) > tolerance) {
                denominator++;
                fraction = fractionalPart * denominator;
                numerator = Math.round(fraction);
            }

            return `${integerPart} ${numerator}/${denominator}`;
        },


        decimalToFraction(decimal) {
            // decimal = this.$helpers.nearestValue(decimal);
            const integerPart = Math.floor(decimal);
            const fractionalPart = decimal - integerPart;

            if (fractionalPart === 0) {
                return integerPart.toString(); // Return only the integer part if there's no fraction
            }

            // Convert the fractional part to a fraction
            const tolerance = 1.0E-6;  // Tolerance for floating-point precision
            let numerator = 1;
            let denominator = 1;
            let fraction = fractionalPart;

            while (Math.abs(fraction - Math.round(fraction)) > tolerance) {
                denominator++;
                fraction = fractionalPart * denominator;
                numerator = Math.round(fraction);
            }

            return `${integerPart} ${numerator}/${denominator}`;
        },

        resetCustomUnit() {
            // this.isCustomUnit = false;
            // this.recipe_amount_uom = '';
            // this.serving_amount_uom = '';
            this.recipe_amount_uom = this.ingredient.recipe_amount_custom_uom;
            this.serving_amount_uom = this.ingredient.serving_amount_custom_uom;
            this.custom_sizing_recipe_amount = null;
            // this.isCustomUnit = false;
            // console.log("this.ingredient", this.ingredient.recipe_amount_uom, this.ingredient.recipe_amount_uom, this.ingredient);


        },
        removePipeCharacters(value) {
            let cuom = this.selectedCustomUnitOfMeasurement;
            if (value == null) {
                return value;
            }
            if (cuom == null) {
                return value;
            }
            var pipeReplacedVal = value.replace(/\|\|/g, "");
            if (cuom?.is_usda) {
                pipeReplacedVal = '^ ' +pipeReplacedVal;
            }
            return pipeReplacedVal +' ('+ this.formatFloat(cuom.weight) + this.$helpers.getUnitNickName(cuom.weight_units) +')';
        },

        formatFloat(value) {
            const num = Number(value);
            if (isNaN(num)) {
                return value; // or return 0, or handle invalid number cases
            }
            return parseFloat(num.toFixed(10)).toString();
        },

        customUnitTooltip() {
            let cuom = this.selectedCustomUnitOfMeasurement;
            if(cuom)
            {
                return this.formatFloat(cuom.weight) + this.$helpers.getUnitNickName(cuom.weight_units) + ' = '+ this.formatFloat(cuom.unit_amount) + this.$helpers.getUnitNickName(cuom.unit_type) ;
            } else {
                return '';
                // return pipeReplacedVal;
            }
            
        },

        sumOfCusomRecipeAmount() {
            let in_model_custom_sizing_recipe_amount_uom = this.$helpers.uomType(this.in_model_custom_sizing_recipe_amount_uom);

            let recipe_amount_uom = this.recipe_amount_uom;

            if (this.recipe_amount_custom_uom && this.recipe_amount_custom_uom != '') {
                recipe_amount_uom = this.recipe_amount_custom_uom;
            }

            let in_model_custom_sizing_main_recipe_amount = this.getConvertToDecimal(this.in_model_custom_sizing_main_recipe_amount);

            let custom_sizing_recipe_amount = this.getConvertToDecimal(this.custom_sizing_recipe_amount);

            console.log("sumOfCusomRecipeAmount", in_model_custom_sizing_main_recipe_amount, custom_sizing_recipe_amount, in_model_custom_sizing_recipe_amount_uom, this.in_model_custom_sizing_recipe_amount_uom);

            let totalRecipeAmount = 0;
            if (in_model_custom_sizing_recipe_amount_uom === 'Weight') {
                if (in_model_custom_sizing_main_recipe_amount > 0) {
                    totalRecipeAmount += parseFloat(this.$conversions.weight(in_model_custom_sizing_main_recipe_amount, recipe_amount_uom, this.custom_sizing_recipe_amount_uom));
                }
                totalRecipeAmount += parseFloat(custom_sizing_recipe_amount);
                totalRecipeAmount = parseFloat(this.$conversions.weight(totalRecipeAmount, this.custom_sizing_recipe_amount_uom, recipe_amount_uom));
            }

            if (in_model_custom_sizing_recipe_amount_uom === 'Volume') {
                if (in_model_custom_sizing_main_recipe_amount > 0) {
                    totalRecipeAmount += parseFloat(this.$conversions.volume(in_model_custom_sizing_main_recipe_amount, recipe_amount_uom, this.custom_sizing_recipe_amount_uom));
                }
                totalRecipeAmount += parseFloat(custom_sizing_recipe_amount);
                totalRecipeAmount = parseFloat(this.$conversions.volume(totalRecipeAmount, this.custom_sizing_recipe_amount_uom, recipe_amount_uom));
            }

            if (in_model_custom_sizing_recipe_amount_uom === 'Unit') {
                if (in_model_custom_sizing_main_recipe_amount > 0) {
                    totalRecipeAmount += parseFloat(in_model_custom_sizing_main_recipe_amount);
                }
                totalRecipeAmount += parseFloat(custom_sizing_recipe_amount);
            }


            // console.log('in_model_custom_sizing_main_recipe_amount', this.in_model_custom_sizing_recipe_amount_uom, this.getCustomUnitOfMeasurement(this.in_model_custom_sizing_recipe_amount_uom));

            if (in_model_custom_sizing_recipe_amount_uom === 'Custom') {
                if (in_model_custom_sizing_main_recipe_amount > 0) {

                    let c = this.getCustomUnitOfMeasurement(this.in_model_custom_sizing_recipe_amount_uom);

                    let unit_type = this.$helpers.uomType(c.unit_type);

                    if (unit_type == 'Custom') {
                        unit_type = 'Unit';
                    }
                    if (in_model_custom_sizing_main_recipe_amount > 0) {

                        if (unit_type == 'Volume') {
                            // console.log("check unit_type -1 ", c.unit_type, custom_sizing_recipe_amount, c.unit_amount, custom_sizing_recipe_amount * c.unit_amount);


                            // console.log("check unit_type 0 totalRecipeAmount ", custom_sizing_recipe_amount * c.unit_amount, c.unit_type, recipe_amount_uom);

                            totalRecipeAmount += parseFloat(this.$conversions.volume(custom_sizing_recipe_amount * c.unit_amount, c.unit_type, recipe_amount_uom));

                            // console.log("check unit_type 1 totalRecipeAmount ", totalRecipeAmount);
                        }

                        // totalRecipeAmount = parseFloat(this.$conversions.volume(totalRecipeAmount, this.custom_sizing_recipe_amount_uom, recipe_amount_uom));
                        // console.log("check unit_type 3 totalRecipeAmount", totalRecipeAmount);


                        if (unit_type == 'Weight') {
                            totalRecipeAmount += parseFloat(this.$conversions.weight(custom_sizing_recipe_amount * c.unit_amount, c.unit_type, recipe_amount_uom));
                        }

                        if (unit_type == 'Unit') {
                            totalRecipeAmount += parseFloat(custom_sizing_recipe_amount * c.unit_amount);
                        }

                        totalRecipeAmount += parseFloat(in_model_custom_sizing_main_recipe_amount);

                        console.log("check unit_type 2 totalRecipeAmount ", totalRecipeAmount);

                    }
                    // console.log("unit_type - ", unit_type);

                    // console.log('in_model_custom_sizing_main_recipe_amount', this.in_model_custom_sizing_recipe_amount_uom, this.getCustomUnitOfMeasurement(this.in_model_custom_sizing_recipe_amount_uom));

                    // totalRecipeAmount += parseFloat(in_model_custom_sizing_main_recipe_amount);
                }
                // totalRecipeAmount += parseFloat(custom_sizing_recipe_amount);
            }

            return totalRecipeAmount;
        },

        saveCustomSizing() {

            this.multipleUnitsOfMeasureModel = false;
            this.custom_sizing_recipe_amount = this.in_model_custom_sizing_recipe_amount;
            this.custom_sizing_recipe_amount_uom = this.in_model_custom_sizing_recipe_amount_uom;

            this.custom_sizing_main_recipe_amount = this.in_model_custom_sizing_main_recipe_amount;

            if (this.getConvertToDecimal(this.custom_sizing_recipe_amount) > 0) {
                this.recipe_amount = this.sumOfCusomRecipeAmount();
            } else {
                this.recipe_amount = this.getConvertToDecimal(this.in_model_custom_sizing_main_recipe_amount);

                console.log('is convert? ', this.recipe_amount_fractions, this.isConvertOrNot(this.recipe_amount_fractions));
                if (this.isConvertOrNot(this.recipe_amount_fractions)) {
                    this.recipe_amount_fractions = this.decimalToFraction(this.convertToFix(this.recipe_amount));
                } else {
                    this.recipe_amount_fractions = this.convertToFix(this.recipe_amount);
                }

            }

            this.handleChangeRecipeAmount();
            this.getRecipeIngredientDataOnChange();
        },


        openUomModel() {
            this.multipleUnitsOfMeasureModel = true;
            this.in_model_custom_sizing_recipe_amount = this.custom_sizing_recipe_amount;
            this.in_model_custom_sizing_recipe_amount_uom = this.custom_sizing_recipe_amount_uom;

            this.in_model_custom_sizing_main_recipe_amount = this.custom_sizing_main_recipe_amount;
            if (this.custom_sizing_main_recipe_amount <= 0) {
                this.in_model_custom_sizing_main_recipe_amount = this.recipe_amount;
            }

            this.multipleUomForIngredients();
        },



        multipleUomForIngredients() {
            console.log('function is call', this.isCustomUnit);
            this.availableUomsforCustomSizing = [];
            this.availableUnitGroups = [];

            const RecipeAmountUomType = this.$helpers.uomType(this.recipe_amount_uom);
            if (RecipeAmountUomType === 'Weight' || RecipeAmountUomType === 'Volume' || RecipeAmountUomType === 'Unit') {
                this.availableUomsforCustomSizing.push(RecipeAmountUomType);
                this.availableUnitGroups = this.availableUoms;
            }

            if (RecipeAmountUomType === 'Custom') {
                this.availableUnitGroups = this.availableCustomUoms;
                const RecipeAmountUomType = this.$helpers.uomType(this.recipe_amount_custom_uom);
                if (RecipeAmountUomType === 'Weight' || RecipeAmountUomType === 'Volume' || RecipeAmountUomType === 'Unit') {
                    this.availableUomsforCustomSizing.push(RecipeAmountUomType);
                }
                // this.availableUomsforCustomSizing.push();
            }
        },

        convertToFix(vals) {
            if (vals > 0 && this.isFloat(vals)) {
                return vals.toFixed(2);
            } else {
                return vals;
            }
        },
        isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        },

        showOptionalComponentsMethod() {
            this.show_optional_components = true;
        },
        hideOptionalComponentsMethod() {
            this.show_optional_components = false;

            this.componentOverrideData.optional_component_mma = null;
            this.componentOverrideData.optional_component_wgr = null;
            this.componentOverrideData.optional_component_fru = null;
            this.componentOverrideData.optional_component_mlk = null;
            this.componentOverrideData.optional_component_veg = null;
            this.componentOverrideData.optional_component_dg = null;
            this.componentOverrideData.optional_component_ro = null;
            this.componentOverrideData.optional_component_leg = null;
            this.componentOverrideData.optional_component_star = null;
            this.componentOverrideData.optional_component_other = null;

            this.updateOptionalComponents();
        },

        updateOptionalComponents(val_array) {
            this.$emit('updateOptionalComponentsParent', val_array);
        },

        onIngredientDeleteMethod() {
            this.$emit('onIngredientDelete');
        },

        handleChangeRecipeAmount() {
            if (this.recipe_amount == 0) {
                this.resetValuesOnZero();
                this.serving_amount_fractions = 0;
                this.serving_amount = 0;
                return false;
            }

            const RecipeAmountUomType = this.$helpers.uomType(this.recipe_amount_uom);
            console.log('RecipeAmountUomType', RecipeAmountUomType);
            const ServingAmountUomType = this.$helpers.uomType(this.serving_amount_uom);

            if (RecipeAmountUomType !== 'Custom' && ServingAmountUomType !== 'Custom') {
                if (RecipeAmountUomType === ServingAmountUomType && RecipeAmountUomType === "Weight") {
                    this.serving_amount = this.$conversions.weight(this.recipe_amount, this.recipe_amount_uom, this.serving_amount_uom) / this.recipe_portion;
                }

                if (RecipeAmountUomType === ServingAmountUomType && RecipeAmountUomType === "Volume") {
                    this.serving_amount = this.$conversions.volume(this.recipe_amount, this.recipe_amount_uom, this.serving_amount_uom) / this.recipe_portion;
                }
            }

            if (RecipeAmountUomType === 'Weight' && ServingAmountUomType === 'Volume') {
                this.serving_amount = this.$conversions.weightToVolume(this.preferred_product_information, this.recipe_amount, this.recipe_amount_uom, this.serving_amount_uom) / this.recipe_portion;
            }

            if (RecipeAmountUomType === 'Volume' && ServingAmountUomType === 'Weight') {
                this.serving_amount = this.$conversions.volumeToWeight(this.preferred_product_information, this.recipe_amount, this.recipe_amount_uom, this.serving_amount_uom) / this.recipe_portion
            }

            if (RecipeAmountUomType === 'Unit' || ServingAmountUomType === 'Unit') {
                this.serving_amount = this.recipe_amount / this.recipe_portion;
            }

            if (RecipeAmountUomType === 'Weight' && ServingAmountUomType === 'Unit') {
                this.serving_amount = this.$conversions.weightToUnit(this.preferred_product_information, this.recipe_amount, this.recipe_amount_uom, this.serving_amount_uom) / this.recipe_portion;
            }

            if (RecipeAmountUomType === 'Unit' && ServingAmountUomType === 'Weight') {
                this.serving_amount = this.$conversions.unitToWeight(this.preferred_product_information, this.recipe_amount, this.recipe_amount_uom, this.serving_amount_uom) / this.recipe_portion
            }

            if (RecipeAmountUomType === 'Volume' && ServingAmountUomType === 'Unit') {
                this.serving_amount = this.$conversions.volumeToUnit(this.preferred_product_information, this.recipe_amount, this.recipe_amount_uom, this.serving_amount_uom) / this.recipe_portion
            }

            if (RecipeAmountUomType === 'Unit' && ServingAmountUomType === 'Volume') {
                this.serving_amount = this.$conversions.unitToVolume(this.preferred_product_information, this.recipe_amount, this.recipe_amount_uom, this.serving_amount_uom) / this.recipe_portion
            }

            /**
             * Custom Unit
             */
            const RecipeAmountCustomUomType = this.$helpers.uomType(this.recipe_amount_custom_uom);

            if (RecipeAmountCustomUomType === 'Weight' && ServingAmountUomType === 'Custom' && this.cuoms) {
                let cuom = this.selectedCustomUnitOfMeasurement;
                if (cuom !== undefined && Object.keys(cuom).length > 0) {

                    if (this.$helpers.uomType(this.serving_amount_custom_uom) === 'Weight') {
                        console.log('onchange recipe amount if', this.serving_amount);
                        this.serving_amount = this.convertToFix(this.$conversions.weight(this.recipe_amount, this.recipe_amount_custom_uom, this.serving_amount_custom_uom) / this.recipe_portion);
                        console.log('onchange recipe amount new else', this.serving_amount);
                    }
                    else if (this.$helpers.uomType(this.serving_amount_custom_uom) === 'Volume') {
                        console.log('onchange recipe amount else', this.serving_amount);
                        this.serving_amount = this.convertToFix(this.$conversions.weightToVolume(this.preferred_product_information, this.recipe_amount, this.recipe_amount_custom_uom, this.serving_amount_custom_uom, [cuom]) / this.recipe_portion);
                        console.log('onchange recipe amount new else', this.serving_amount);
                    }
                    else {
                        var sAmount = this.$conversions.weight(this.recipe_amount, this.recipe_amount_custom_uom, cuom.weight_units) / this.recipe_portion;
                        var cportion = cuom.weight / cuom.unit_amount;
                        this.serving_amount = this.convertToFix(sAmount / cportion);
                    }
                }
            }

            if (RecipeAmountCustomUomType === 'Volume' && ServingAmountUomType === 'Custom' && this.cuoms) {
                let cuom = this.selectedCustomUnitOfMeasurement;
                if (cuom !== undefined && Object.keys(cuom).length > 0) {

                    if (this.$helpers.uomType(this.serving_amount_custom_uom) === 'Weight') {
                        console.log('onchange recipe amount if', this.serving_amount);
                        let Cweight = this.convertToFix(this.$conversions.volumeToWeight(this.preferred_product_information, this.recipe_amount, this.recipe_amount_custom_uom, this.serving_amount_custom_uom, [cuom]) / this.recipe_portion);
                        // let rp = cuom.unit_amount / cuom.weight;
                        // this.serving_amount = Cweight * rp;
                        this.serving_amount = Cweight;
                    } else {
                        console.log('onchange recipe amount else', this.serving_amount);
                        this.serving_amount = this.$conversions.volume(this.recipe_amount, this.recipe_amount_custom_uom, this.serving_amount_custom_uom) / this.recipe_portion;
                        console.log('onchange recipe amount else aa', this.serving_amount);
                    }


                }
            }

            console.log('onchange recipe amount last 1', this.serving_amount);

            if (this.$helpers.uomType(this.recipe_amount_custom_uom) === 'Unit') {
                if (this.$helpers.uomType(this.serving_amount_custom_uom) === 'Unit') {
                    this.serving_amount = this.recipe_amount / this.recipe_portion;
                }

                if (this.$helpers.uomType(this.serving_amount_custom_uom) === 'Weight') {
                    let cuom = this.selectedCustomUnitOfMeasurement;
                    console.log('onchange recipe amount last 3', this.serving_amount);
                    let sAmount = this.recipe_amount / this.recipe_portion;
                    var cportion = cuom.weight / cuom.unit_amount;
                    sAmount = sAmount * cportion;

                    this.serving_amount = this.$conversions.weight(sAmount, cuom.weight_units, this.serving_amount_custom_uom);
                }

            }


            this.handleChangeComponentUpdate(this.component_scale);
            this.getRecipeIngredientDataOnChange();
            this.isMounted = true;

            console.log('is convert? ', this.serving_amount_fractions, this.isConvertOrNot(this.serving_amount_fractions));

            if (this.isConvertOrNot(this.serving_amount_fractions)) {
                this.serving_amount_fractions = this.decimalToFraction(this.convertToFix(this.serving_amount));
            } else {
                this.serving_amount_fractions = this.convertToFix(this.serving_amount);
            }

            // this.serving_amount_fractions = this.decimalToFraction(this.serving_amount);
        },




        handleChangeServingAmount() {

            console.log("handleChangeServingAmount");
            // console.log('handleChangeServingAmount Custom Volume');
            if (this.serving_amount == 0) {
                this.resetValuesOnZero();
                this.recipe_amount = 0;
                this.recipe_amount_fractions = 0;
                return false;
            }

            let cuom = this.selectedCustomUnitOfMeasurement;
            // console.log("handleChangeServingAmount")

            //let recipeAmount = 0;
            const RecipeAmountUomType = this.$helpers.uomType(this.recipe_amount_uom);
            const ServingAmountUomType = this.$helpers.uomType(this.serving_amount_uom);
            console.log("handleChangeServingAmount", RecipeAmountUomType, ServingAmountUomType);


            if (RecipeAmountUomType === ServingAmountUomType && RecipeAmountUomType === "Weight") {
                this.recipe_amount = this.$conversions.weight(this.serving_amount, this.serving_amount_uom, this.recipe_amount_uom) * this.recipe_portion;
            }

            if (RecipeAmountUomType === ServingAmountUomType && RecipeAmountUomType === "Volume") {
                this.recipe_amount = this.$conversions.volume(this.serving_amount, this.serving_amount_uom, this.recipe_amount_uom) * this.recipe_portion;
            }

            if (RecipeAmountUomType === 'Weight' && ServingAmountUomType === 'Volume') {
                this.recipe_amount = this.$conversions.volumeToWeight(this.preferred_product_information, this.serving_amount, this.serving_amount_uom, this.recipe_amount_uom) * this.recipe_portion;
            }

            if (RecipeAmountUomType === 'Volume' && ServingAmountUomType === 'Weight') {
                this.recipe_amount = this.$conversions.weightToVolume(this.preferred_product_information, this.serving_amount, this.serving_amount_uom, this.recipe_amount_uom) * this.recipe_portion
            }

            if (RecipeAmountUomType === 'Unit' || ServingAmountUomType === 'Unit') {
                this.recipe_amount = this.serving_amount * this.recipe_portion;
            }

            if (RecipeAmountUomType === 'Unit' && ServingAmountUomType === 'Weight') {
                this.recipe_amount = this.$conversions.weightToUnit(this.preferred_product_information, this.serving_amount, this.serving_amount_uom, this.recipe_amount_uom) * this.recipe_portion
            }

            if (RecipeAmountUomType === 'Unit' && ServingAmountUomType === 'Volume') {
                this.recipe_amount = this.$conversions.volumeToUnit(this.preferred_product_information, this.serving_amount, this.serving_amount_uom, this.recipe_amount_uom) * this.recipe_portion
            }

            if (RecipeAmountUomType === 'Weight' && ServingAmountUomType === 'Unit') {
                this.recipe_amount = this.$conversions.unitToWeight(this.preferred_product_information, this.serving_amount, this.serving_amount_uom, this.recipe_amount_uom) * this.recipe_portion;
            }

            if (RecipeAmountUomType === 'Volume' && ServingAmountUomType === 'Unit') {
                this.recipe_amount = this.$conversions.unitToVolume(this.preferred_product_information, this.serving_amount, this.serving_amount_uom, this.recipe_amount_uom) * this.recipe_portion;
            }

            /**
             * Custom Units
             */

            const RecipeAmountCustomUomType = this.$helpers.uomType(this.recipe_amount_custom_uom);

            const ServingAmountCustomUomType = this.$helpers.uomType(this.serving_amount_custom_uom);

            let isEqule = RecipeAmountCustomUomType === ServingAmountCustomUomType;
            // isEqule = false;

            console.log('handleChangeServingAmount isEqule', isEqule, RecipeAmountCustomUomType, ServingAmountCustomUomType);

            if (isEqule && RecipeAmountUomType === 'Custom') {
                if (RecipeAmountCustomUomType === 'Weight' && ServingAmountCustomUomType === 'Weight') {
                    this.recipe_amount = this.$conversions.weight(this.serving_amount, this.serving_amount_custom_uom, this.recipe_amount_custom_uom) * this.recipe_portion;
                }

                if (RecipeAmountCustomUomType === 'Volume' && ServingAmountCustomUomType === 'Volume') {
                    this.recipe_amount = this.$conversions.volume(this.serving_amount, this.serving_amount_custom_uom, this.recipe_amount_custom_uom) * this.recipe_portion;
                }

                // this.recipe_amount = this.serving_amount * this.recipe_portion;
            }

            if (!isEqule && RecipeAmountUomType === 'Custom' && RecipeAmountCustomUomType === 'Weight' && ServingAmountCustomUomType === 'Volume' && this.cuoms) {
                if (cuom !== undefined && Object.keys(cuom).length > 0) {
                    this.recipe_amount = this.convertToFix(this.$conversions.volumeToWeight(this.preferred_product_information, this.serving_amount, this.serving_amount_custom_uom, cuom.weight_units, [cuom]) * this.recipe_portion);

                    // let rp = cuom.unit_amount / cuom.weight;
                    // this.recipe_amount = Cweight * rp;
                    console.log('handleChangeServingAmount Custom - Weight  Volume');
                }
            }

            if (!isEqule && RecipeAmountUomType === 'Custom' && RecipeAmountCustomUomType === 'Weight' && ServingAmountCustomUomType === 'Unit' && this.cuoms) {
                if (cuom !== undefined && Object.keys(cuom).length > 0) {

                    let rp = cuom.unit_amount / cuom.weight;
                    let Cweight = this.serving_amount / rp;
                    this.recipe_amount = this.$conversions.weight(Cweight, cuom.weight_units, this.recipe_amount_custom_uom) * this.recipe_portion;
                    // this.recipe_amount = Cweight / rp;
                    console.log('handleChangeServingAmount Custom - Weight  Unit');
                }
            }

            if (!isEqule && RecipeAmountUomType === 'Custom' && RecipeAmountCustomUomType === 'Volume' && ServingAmountCustomUomType === 'Weight' && this.cuoms) {
                if (cuom !== undefined && Object.keys(cuom).length > 0) {
                    this.recipe_amount = this.convertToFix(this.$conversions.weightToVolume(this.preferred_product_information, this.serving_amount, this.serving_amount_custom_uom, this.recipe_amount_custom_uom, [cuom]) * this.recipe_portion);

                    // let rp = cuom.unit_amount / cuom.weight;
                    // this.recipe_amount = Cweight * rp;
                    console.log('handleChangeServingAmount Custom - Volume  Weight');
                }
            }

            if (!isEqule && RecipeAmountUomType === 'Custom' && RecipeAmountCustomUomType === 'Unit' && ServingAmountCustomUomType === 'Weight' && this.cuoms) {
                if (cuom !== undefined && Object.keys(cuom).length > 0) {

                    let rp = cuom.unit_amount / cuom.weight;

                    this.recipe_amount = this.$conversions.weight(this.serving_amount, this.serving_amount_custom_uom, cuom.weight_units) * this.recipe_portion * rp;

                    // this.recipe_amount = this.convertToFix(this.$conversions.weightToVolume(this.preferred_product_information, this.serving_amount, this.serving_amount_custom_uom, this.recipe_amount_custom_uom, [cuom]) * this.recipe_portion);

                    // let rp = cuom.unit_amount / cuom.weight;
                    // this.recipe_amount = Cweight * rp;
                    console.log('handleChangeServingAmount Custom - Unit  Weight');
                }
            }

            console.log("this.component_scale", this.component_scale);

            //this.recipe_amount = recipeAmount;
            this.handleChangeComponentUpdate(this.component_scale);
            this.getRecipeIngredientDataOnChange();

            console.log('is convert? ', this.recipe_amount_fractions, this.isConvertOrNot(this.recipe_amount_fractions));

            if (this.isConvertOrNot(this.recipe_amount_fractions)) {
                this.recipe_amount_fractions = this.decimalToFraction(this.convertToFix(this.recipe_amount));
            } else {
                this.recipe_amount_fractions = this.convertToFix(this.recipe_amount);
            }

            // this.recipe_amount_fractions = this.decimalToFraction(this.recipe_amount);
        },

        handleChangeComponentValue(newScale) {
            let scaledAmount = 0;
            let servingAmount = 0;

            // console.log('newScale', newScale);
            const ServingAmountUomType = this.$helpers.uomType(this.serving_amount_uom);

            if (ServingAmountUomType === "Weight") {
                scaledAmount = this.preferred_product_information.nutrition_facts_weight * newScale;
                // console.log('scaledAmount', scaledAmount)
                servingAmount = this.$conversions.weight(scaledAmount, this.preferred_product_information.nutrition_facts_weight_uom, this.serving_amount_uom)

            }

            if (ServingAmountUomType === "Volume") {
                scaledAmount = this.preferred_product_information.nutrition_facts_volume * newScale;
                servingAmount = this.$conversions.volume(scaledAmount, this.preferred_product_information.nutrition_facts_volume_uom, this.serving_amount_uom)

            }


            this.serving_amount = servingAmount;

            if (this.isConvertOrNot(this.serving_amount_fractions)) {
                this.serving_amount_fractions = this.decimalToFraction(this.convertToFix(this.serving_amount));
            } else {
                this.serving_amount_fractions = this.convertToFix(this.serving_amount);
            }


            this.handleChangeServingAmount();

            this.handleChangeComponentUpdate(newScale);
            this.getRecipeIngredientDataOnChange();

        },


        handleChangeComponentUpdate(newScale) {
            console.log('preferred_product_information', this.preferred_product_information.component_mma);
            console.log('preferred_product_information scale', newScale);
            this.component_mma = newScale * this.preferred_product_information.component_mma;
            this.component_wgr = newScale * this.preferred_product_information.component_wgr;
            this.component_fru = newScale * this.preferred_product_information.component_fru;
            this.component_mlk = newScale * this.preferred_product_information.component_mlk;
            this.component_veg = newScale * this.preferred_product_information.component_veg;
            this.component_dg = newScale * this.preferred_product_information.component_dg;
            this.component_ro = newScale * this.preferred_product_information.component_ro;
            this.component_leg = newScale * this.preferred_product_information.component_leg;
            this.component_star = newScale * this.preferred_product_information.component_star;
            this.component_other = newScale * this.preferred_product_information.component_other;
        },

        getRecipeIngredientDataOnChange() {
            // alert('getRecipeIngredientDataOnChange');
            setTimeout(() => {
                let data_values = {};
                data_values['recipe_amount'] = this.recipe_amount;
                data_values['serving_amount'] = this.serving_amount;

                data_values['serving_amount_fractions'] = this.serving_amount_fractions;
                data_values['recipe_amount_fractions'] = this.recipe_amount_fractions;

                data_values['recipe_amount_uom'] = this.recipe_amount_uom;

                data_values['custom_sizing_main_recipe_amount'] = this.custom_sizing_main_recipe_amount;

                data_values['custom_sizing_recipe_amount'] = this.custom_sizing_recipe_amount;
                data_values['custom_sizing_recipe_amount_uom'] = this.custom_sizing_recipe_amount_uom;

                data_values['recipe_amount_custom_uom'] = this.recipe_amount_custom_uom;
                data_values['serving_amount_uom'] = this.serving_amount_uom;
                data_values['serving_amount_custom_uom'] = this.serving_amount_custom_uom;

                data_values['component_mma'] = this.component_mma;
                data_values['component_wgr'] = this.component_wgr;
                data_values['component_fru'] = this.component_fru;
                data_values['component_mlk'] = this.component_mlk;
                data_values['component_veg'] = this.component_veg;
                data_values['component_dg'] = this.component_dg;
                data_values['component_ro'] = this.component_ro;
                data_values['component_leg'] = this.component_leg;
                data_values['component_star'] = this.component_star;
                data_values['component_other'] = this.component_other;
                console.log("data_values", data_values);
                this.$emit('getDataRecipeIngredient', data_values);
            }, 1000);

        },

        resetValuesOnZero() {
            this.recipe_amount = '';
            this.serving_amount = '';
            this.component_mma = 0;
            this.component_wgr = 0;
            this.component_fru = 0;
            this.component_mlk = 0;
            this.component_veg = 0;
            this.component_dg = 0;
            this.component_ro = 0;
            this.component_leg = 0;
            this.component_star = 0;
            this.component_other = 0;
            this.getRecipeIngredientDataOnChange();
        },

        // handleChangeComponentValue(newScale) {
        //   this.component_scale = newScale;
        //   this.serving_amount = this.serving_amount_original * newScale;
        // }

        getBaseServingAmount() {
            // console.log(' 👉 getBaseServingAmount', this.$helpers.uomType(this.serving_amount_uom))

            // Weight, Volume, or Unit ?
            const uomType = this.$helpers.uomType(this.serving_amount_uom);
            console.log('uomType getBaseServingAmount', uomType);
            if (uomType === 'Weight') {
                return this.preferred_product_information.nutrition_facts_weight
            }

            if (uomType === 'Volume') {
                return this.preferred_product_information.nutrition_facts_volume
            }

            if (uomType === 'Unit') {
                return this.preferred_product_information.nutrition_facts_unit
            }

            if (uomType === 'Custom') {
                return this.ingredient.serving_amount;
            }


            // Error
            return -1;
        },
        getServingAmountScale() {
            console.log('scale', this.component_scale);
        },

        getCustomUnit(Cuom) {
            let cuomsArray = null;
            if (this.cuoms) {
                for (let i = 0; i < this.cuoms.length; i++) {
                    if (this.cuoms[i].description1 == Cuom) {
                        cuomsArray = this.cuoms[i];
                    }
                }
            }

            return cuomsArray;
        },
        getUmoName(name) {
            let cuom = this.getCustomUnit(name);
            if (cuom) {
                return cuom.description;
            } else {
                return name;
            }
        }
    },
    computed: {

        component_scale() {
            const currentServingAmount = this.serving_amount;
            const uomType = this.$helpers.uomType(this.serving_amount_uom);

            console.log('component_scale', currentServingAmount, uomType);

            let baseAmount = null
            let baseAmountUoM = null
            let convertedAmount = null

            if (uomType === 'Weight') {

                baseAmount = this.preferred_product_information.serving_component_weight;
                baseAmountUoM = this.preferred_product_information.serving_component_weight_uom;
                convertedAmount = this.$conversions.weight(baseAmount, baseAmountUoM, this.serving_amount_uom);
                console.log("component_scale in Custom Weight", baseAmount, baseAmountUoM, this.serving_amount_uom, convertedAmount)
            }

            if (uomType === 'Volume') {

                baseAmount = this.preferred_product_information.serving_component_volume;
                baseAmountUoM = this.preferred_product_information.serving_component_volume_uom;

                convertedAmount = this.$conversions.volume(baseAmount, baseAmountUoM, this.serving_amount_uom);

                console.log("baseAmount", convertedAmount, baseAmount, baseAmountUoM, this.serving_amount_uom);
            }

            if (uomType === 'Unit') {
                baseAmount = this.preferred_product_information.nutrition_facts_unit
                convertedAmount = baseAmount;
                console.log('component_scale baseAmount', baseAmount);
                console.log('component_scale convertedAmount', convertedAmount);
            }


            if (uomType === 'Custom') {
                const cuom = this.selectedCustomUnitOfMeasurement;
                if (cuom !== undefined && Object.keys(cuom).length > 0) {

                    if (this.$helpers.uomType(this.serving_amount_custom_uom) === 'Weight') {
                        // baseAmount = cuom.weight;
                        // baseAmountUoM = this.serving_amount_custom_uom;
                        // convertedAmount = this.$conversions.weight(baseAmount, cuom.weight_units, this.serving_amount_custom_uom);

                        // new
                        baseAmount = this.preferred_product_information.serving_component_weight;
                        baseAmountUoM = this.preferred_product_information.serving_component_weight_uom;
                        convertedAmount = this.$conversions.weight(baseAmount, baseAmountUoM, this.serving_amount_custom_uom);
                        // convertedAmount = baseAmount;
                    } else if (this.$helpers.uomType(this.serving_amount_custom_uom) === 'Volume') {

                        // let newconvertedAmount = (cuom.weight / this.preferred_product_information.serving_component_weight);

                        baseAmount = this.preferred_product_information.serving_component_weight;
                        baseAmountUoM = this.preferred_product_information.serving_component_weight_uom;
                        convertedAmount = this.$conversions.weight(baseAmount, baseAmountUoM, cuom.weight_units);
                        let baseAmountScale = convertedAmount / cuom.weight;
                        console.log('scale_factor baseAmountScale ', baseAmountScale);

                        // Old
                        baseAmount = cuom.unit_amount * baseAmountScale;
                        baseAmountUoM = this.serving_amount_custom_uom;
                        convertedAmount = this.$conversions.volume(baseAmount, cuom.unit_type, this.serving_amount_custom_uom);

                        // console.log('scale_factor in Custom Volume', baseAmount, baseAmountUoM, this.serving_amount_custom_uom, convertedAmount)

                        // convertedAmount = (cuom.weight / baseAmount) * convertedAmount;

                        // console.log('scale_factor after in Custom Volume', baseAmount, baseAmountUoM, this.serving_amount_custom_uom, convertedAmount)

                        // new
                        // baseAmount = this.preferred_product_information.serving_component_volume;
                        // baseAmountUoM = this.preferred_product_information.serving_component_volume_uom;

                        // convertedAmount = this.$conversions.volume(baseAmount, baseAmountUoM, this.serving_amount_custom_uom);

                    } else if (this.$helpers.uomType(this.serving_amount_custom_uom) === 'Unit') {
                        baseAmount = this.preferred_product_information.serving_component_weight;
                        baseAmountUoM = this.preferred_product_information.serving_component_weight_uom;
                        convertedAmount = this.$conversions.weight(baseAmount, baseAmountUoM, cuom.weight_units);
                        let baseAmountScale = convertedAmount / cuom.weight;
                        console.log('scale_factor baseAmountScale ', baseAmountScale);

                        baseAmount = cuom.unit_amount * baseAmountScale;
                        baseAmountUoM = this.serving_amount_custom_uom;
                        convertedAmount = baseAmount;

                        // baseAmount = cuom.unit_amount;
                        // baseAmountUoM = this.serving_amount_custom_uom;
                        // convertedAmount = baseAmount;

                        // new
                        // baseAmount = this.preferred_product_information.nutrition_facts_unit
                        // convertedAmount = baseAmount;
                    }
                    //     console.log('component_scale baseAmount', baseAmount);
                    // console.log('component_scale convertedAmount', convertedAmount);

                }
            }

            let scale_factor = currentServingAmount / convertedAmount;


            console.log('✅');
            console.log('scale_factor', scale_factor, currentServingAmount, convertedAmount);

            if (isFinite(scale_factor) && !isNaN(scale_factor)) {
                return Math.round((scale_factor + Number.EPSILON) * 100) / 100;
                return scale_factor;
            }


        },
        availableUoms() {
            let uoms = [];

            if ((this.preferred_product_information.nutrition_facts_unit_uom !== null && this.preferred_product_information.nutrition_facts_unit > 0) || (this.preferred_product_information.serving_component_unit_uom !== null && this.preferred_product_information.serving_component_unit > 0)) {
                uoms.push('Unit')
            }
            if ((this.preferred_product_information.nutrition_facts_weight_uom !== null && this.preferred_product_information.nutrition_facts_weight > 0) || (this.preferred_product_information.serving_component_weight_uom !== null && this.preferred_product_information.serving_component_weight > 0)) {
                uoms.push('Weight')
            }
            if ((this.preferred_product_information.nutrition_facts_volume_uom !== null && this.preferred_product_information.nutrition_facts_volume > 0) || (this.preferred_product_information.serving_component_volume_uom !== null && this.preferred_product_information.serving_component_volume > 0)) {
                uoms.push('Volume')
            }
            // console.log('umos Volume', uoms, this.preferred_product_information.nutrition_facts_volume_uom, this.preferred_product_information.nutrition_facts_volume, this.preferred_product_information);
            // console.log('umos ingredients', this.ingredient.cuom);
            // console.log('umos product', this.preferred_product_information);

            // if (this.cuoms && this.cuoms.length > 0) {
            //     for (var i = 0; i < this.cuoms.length; i++) {
            //         // uoms.push( this.$helpers.uomType(this.cuoms[i].unit_type));
            //     }
            // }
            return uoms;
        },
        availableCustomUoms() {
            let cumos = ['Weight'];
            const selectedCuom = this.ingredient.cuom.find(cuom => cuom.description1 === this.recipe_amount_uom);
            if (selectedCuom && Object.keys(selectedCuom).length > 0) {
                let unitType = this.$helpers.uomType(selectedCuom.unit_type);
                cumos.push(unitType);
            }
            return cumos;
        },
        defaultUom() {

            if (this.preferred_product_information.nutrition_facts_volume_uom !== null) {
                return this.preferred_product_information.nutrition_facts_volume_uom;
            }

            if (this.preferred_product_information.nutrition_facts_weight_uom !== null) {
                return this.preferred_product_information.nutrition_facts_weight_uom;
            }

            if (this.preferred_product_information.nutrition_facts_unit_uom !== null) {
                return this.preferred_product_information.nutrition_facts_unit_uom;
            }


            return "Not Found"
        },

        selectedCustomUnitOfMeasurement() {
            console.log('this.recipe_amount_custom_uom', this.recipe_amount_uom)
            return this.cuoms?.find((cuom) => cuom.description1 === this.recipe_amount_uom);
        }
    },
    watch: {
        isCustomUnit(val) {
            if (!val) {
                this.recipe_amount_custom_uom = null;
                this.serving_amount_custom_uom = null;
            }
        },

        recipe_portion() {
            this.handleChangeRecipeAmount();
        },


        recipe_amount_uom(newUom, oldUom) {

            let newRecipeAmount = null;

            const newUomType = this.$helpers.uomType(newUom);
            const oldUomType = this.$helpers.uomType(oldUom);
            if (newUomType === 'Custom' && newUom) {
                // console.error('isCustomUnit', this.isCustomUnit, newUomType, newUom);
                this.isCustomUnit = true;
                const cuom = this.selectedCustomUnitOfMeasurement;
                if (cuom) {
                    this.recipe_amount_custom_uom = cuom.unit_type;
                    this.serving_amount_uom = newUom;
                }

                return;
            } else {
                this.isCustomUnit = false;
            }

            if (this.recipe_amount === null || this.recipe_amount === Infinity) {
                this.recipe_amount = '';
                return;
            }

            console.log(`🧮 recipe_amount_uom Converting ${this.recipe_amount} ${oldUom} to ${newUom}`)

            let initAmount = this.recipe_amount;

            if (newUomType === oldUomType && newUomType === 'Weight') {
                console.log('recipe_amount_uom oldUom', oldUom)
                console.log('recipe_amount_uom newUom', newUom)
                newRecipeAmount = this.$conversions.weight(initAmount, oldUom, newUom);
                console.log('recipe_amount_uom newRecipeAmount', newRecipeAmount)
            }

            if (newUomType === oldUomType && newUomType === 'Volume') {
                newRecipeAmount = this.$conversions.volume(initAmount, oldUom, newUom);
            }

            if (newUomType === 'Weight' && oldUomType === 'Volume') {
                newRecipeAmount = this.$conversions.volumeToWeight(this.preferred_product_information, this.recipe_amount, oldUom, newUom)
            }

            if (newUomType === 'Volume' && oldUomType === 'Weight') {
                newRecipeAmount = this.$conversions.weightToVolume(this.preferred_product_information, this.recipe_amount, oldUom, newUom)
            }

            if (newUomType === oldUomType && newUomType === 'Unit') {
                newRecipeAmount = initAmount;
            }

            if (newUomType === 'Unit' && oldUomType === 'Weight') {
                newRecipeAmount = this.$conversions.weightToUnit(this.preferred_product_information, this.recipe_amount, oldUom, newUom);
                console.log(`🧮 recipe_amount_uom Converting in`, newRecipeAmount);
            }
            if (newUomType === 'Weight' && oldUomType === 'Unit') {
                newRecipeAmount = this.$conversions.unitToWeight(this.preferred_product_information, this.recipe_amount, oldUom, newUom);
                console.log(`🧮 recipe_amount_uom Converting in`, newRecipeAmount);
            }

            if (newUomType === 'Unit' && oldUomType === 'Volume') {
                newRecipeAmount = this.$conversions.volumeToUnit(this.preferred_product_information, this.recipe_amount, oldUom, newUom);
                console.log(`🧮 recipe_amount_uom Converting in`, newRecipeAmount);
            }

            if (newUomType === 'Volume' && oldUomType === 'Unit') {
                newRecipeAmount = this.$conversions.unitToVolume(this.preferred_product_information, this.recipe_amount, oldUom, newUom);
                console.log(`🧮 recipe_amount_uom Converting in`, newRecipeAmount);
            }

            /**
             * Custom Unit
             */
            this.recipe_amount = newRecipeAmount;
            console.log('is convert? ', this.recipe_amount_fractions, this.isConvertOrNot(this.recipe_amount_fractions));

            if (this.isConvertOrNot(this.recipe_amount_fractions)) {
                this.recipe_amount_fractions = this.decimalToFraction(this.convertToFix(this.recipe_amount));
            } else {
                this.recipe_amount_fractions = this.convertToFix(this.recipe_amount);
            }

            // this.recipe_amount_fractions = this.decimalToFraction(this.recipe_amount);
            this.getRecipeIngredientDataOnChange();
        },


        // custom_sizing_recipe_amount_uom(value){
        //     this.getRecipeIngredientDataOnChange();
        // },

        serving_amount_uom(newUom, oldUom) {

            if (this.serving_amount === null) return;

            let newServingAmount = null;

            const newUomType = this.$helpers.uomType(newUom);
            const oldUomType = this.$helpers.uomType(oldUom);

            // console.log('newUomType recipe_amount_uom', newUomType)
            // console.log('newUomType recipe_amount_uom oldUomType', oldUomType)
            if (newUomType === 'Custom') {
                return;
            }

            let initAmount = this.serving_amount;

            if (newUomType === 'Weight') {
                // if(this.preferred_product_information.nutrition_facts_weight_uom == newUom && this.preferred_product_information.nutrition_facts_weight > 0){
                //   newServingAmount = this.preferred_product_information.nutrition_facts_weight;
                // }else{
                newServingAmount = this.$conversions.weight(initAmount, oldUom, newUom);
                // }
            }

            if (newUomType === 'Volume') {
                // if(this.preferred_product_information.nutrition_facts_volume_uom == newUom && this.preferred_product_information.nutrition_facts_volume > 0){
                //   newServingAmount = this.preferred_product_information.nutrition_facts_volume;
                // }else{
                console.log('serving_amount_uom volume', initAmount, oldUom, newUom)
                newServingAmount = this.$conversions.volume(initAmount, oldUom, newUom);
                // }
            }

            if (newUomType === 'Unit') {
                // if(this.preferred_product_information.nutrition_facts_unit_uom == newUom &&  this.preferred_product_information.nutrition_facts_unit > 0){
                //   newServingAmount = this.preferred_product_information.nutrition_facts_unit;
                // }else{
                newServingAmount = initAmount;
                // }
            }

            if (newUomType === 'Weight' && oldUomType === 'Volume') {
                // if(this.preferred_product_information.nutrition_facts_weight_uom == newUom && this.preferred_product_information.nutrition_facts_weight > 0){
                //   newServingAmount = this.preferred_product_information.nutrition_facts_weight;
                // }else{
                newServingAmount = this.$conversions.volumeToWeight(this.preferred_product_information, this.serving_amount, oldUom, newUom);
                // }
                console.log("serving_amount_uom  Weight Volume", newServingAmount);
            }

            if (newUomType === 'Volume' && oldUomType === 'Weight') {
                // if(this.preferred_product_information.nutrition_facts_volume_uom == newUom && this.preferred_product_information.nutrition_facts_volume > 0){
                //   newServingAmount = this.preferred_product_information.nutrition_facts_volume;
                //   console.log("serving_amount_uom Volume Weight if");
                // }else{
                newServingAmount = this.$conversions.weightToVolume(this.preferred_product_information, initAmount, oldUom, newUom);
                // console.log("serving_amount_uom Volume Weight else ", newServingAmount, this.serving_amount,  oldUom, newUom);
                // }
                console.log("serving_amount_uom Volume Weight", newServingAmount);
            }

            if (newUomType === 'Unit' && oldUomType === 'Weight') {
                newServingAmount = this.$conversions.weightToUnit(this.preferred_product_information, initAmount, oldUom, newUom);
            }
            if (newUomType === 'Weight' && oldUomType === 'Unit') {
                newServingAmount = this.$conversions.unitToWeight(this.preferred_product_information, initAmount, oldUom, newUom);
            }

            if (newUomType === 'Unit' && oldUomType === 'Volume') {
                newServingAmount = this.$conversions.volumeToUnit(this.preferred_product_information, initAmount, oldUom, newUom);
            }

            if (newUomType === 'Volume' && oldUomType === 'Unit') {
                newServingAmount = this.$conversions.unitToVolume(this.preferred_product_information, initAmount, oldUom, newUom);
            }

            /**
             * Add Custom Units
             */


            this.serving_amount = this.convertToFix(newServingAmount);

            console.log('is convert? ', this.serving_amount_fractions, this.isConvertOrNot(this.serving_amount_fractions));

            if (this.isConvertOrNot(this.serving_amount_fractions)) {
                this.serving_amount_fractions = this.decimalToFraction(this.convertToFix(this.serving_amount));
            } else {
                this.serving_amount_fractions = this.convertToFix(this.serving_amount);
            }


            // this.serving_amount_fractions = this.decimalToFraction(this.serving_amount);


            // this.serving_amount = this.convertToFix(newServingAmount);
            this.handleChangeComponentUpdate(this.component_scale);
            this.getRecipeIngredientDataOnChange();

        },

        recipe_amount_custom_uom(newVal, oldVal) {
            console.log('serving_amount_custom_uom', newVal, oldVal)
            if (!this.serving_amount_custom_uom) {
                this.serving_amount_custom_uom = newVal;
            }
            let newServingAmount = null;
            let initAmount = this.recipe_amount;

            const newUomType = this.$helpers.uomType(newVal);
            const oldUomType = this.$helpers.uomType(oldVal);
            const cuom = this.selectedCustomUnitOfMeasurement;

            if (newUomType === 'Weight' && (!oldVal || oldUomType === 'Weight') && this.cuoms) {
                // newServingAmount = this.$conversions.weight(this.recipe_amount, oldVal, newVal);

                if (newVal === cuom.weight_units && !oldVal) {
                    newServingAmount = this.recipe_amount / this.recipe_portion;
                } else {
                    newServingAmount = this.$conversions.weight(this.recipe_amount, oldVal, newVal)
                }
            }
            if (oldUomType === 'Weight' && newUomType === 'Volume' && this.cuoms) {
                newServingAmount = this.$conversions.weightToVolume(this.preferred_product_information, initAmount, oldVal, newVal, [cuom]);
            }

            if (oldUomType === 'Volume' && newUomType === 'Weight' && this.cuoms) {
                console.log('conversion volumeToWeight in', oldVal);
                // if (newVal === cuom.weight_units && !oldVal) {
                //     newServingAmount = this.recipe_amount / cuom.unit_amount;
                // } else {
                newServingAmount = this.$conversions.volumeToWeight(this.preferred_product_information, initAmount, oldVal, newVal, [cuom]);
                // newServingAmount = newServingAmount * cuom.unit_amount;
                // }
                console.log('conversion volumeToWeight newServingAmount', newServingAmount, cuom);
            }
            if (oldUomType === 'Volume' && newUomType === oldUomType && this.cuoms) {
                newServingAmount = this.$conversions.volume(this.recipe_amount, oldVal, newVal);
            }

            if (newUomType === 'Unit' && oldUomType === 'Unit') {
                newServingAmount = this.recipe_amount;
            }

            if (newUomType === 'Unit' && oldUomType === 'Weight') {

                newServingAmount = this.recipe_amount;
                if (oldVal != cuom.weight_units) {
                    newServingAmount = this.$conversions.weight(this.recipe_amount, oldVal, cuom.weight_units);
                }
                newServingAmount = newServingAmount / (cuom.weight / cuom.unit_amount);
                console.log('conversion unit unit to weight', newServingAmount);
                // newServingAmount = this.$conversions.unit(this.recipe_amount, oldVal, newVal);
            }

            if (oldUomType === 'Unit' && newUomType === 'Weight') {
                newServingAmount = this.recipe_amount * (cuom.weight / cuom.unit_amount);
                if (newVal != cuom.weight_units) {
                    newServingAmount = this.$conversions.weight(newServingAmount, cuom.weight_units, newVal);
                }
            }

            // if (oldUomType === 'Unit' && newUomType === this.$helpers.uomType(cuom.weight_units)) {
            //     newServingAmount = initAmount / cuom.unit_amount;
            // }
            this.recipe_amount = this.convertToFix(newServingAmount);

            if (this.isConvertOrNot(this.recipe_amount_fractions)) {
                this.recipe_amount_fractions = this.decimalToFraction(this.convertToFix(this.recipe_amount));
            } else {
                this.recipe_amount_fractions = this.convertToFix(this.recipe_amount);
            }
            this.getRecipeIngredientDataOnChange();
        },

        serving_amount_custom_uom(newVal, oldVal) {
            console.log("serving_amount_custom_uom", newVal, oldVal);
            let newServingAmount = null;
            // let initAmount = this.recipe_amount;
            let initAmount = this.serving_amount;

            const newUomType = this.$helpers.uomType(newVal);
            const oldUomType = this.$helpers.uomType(oldVal);
            const cuom = this.selectedCustomUnitOfMeasurement;

            if (newUomType === 'Weight' && (!oldVal || oldUomType === 'Weight') && this.cuoms) {
                console.log("serving_amount_custom_uom Weight in");
                // if (newVal === cuom.weight_units) {
                //     newServingAmount = this.recipe_amount / this.recipe_portion;
                // } else if (newVal === cuom.unit_type) {
                //     newServingAmount = this.recipe_amount * cuom.unit_amount / this.recipe_portion;
                // } else {
                newServingAmount = this.$conversions.weight(this.serving_amount, oldVal, newVal);
                // }
                console.log('recipe_amount_uo_weight_to_weight newServingAmount', newServingAmount);
            }
            //
            if (oldUomType === 'Weight' && newUomType === 'Volume' && this.cuoms) {
                newServingAmount = (this.$conversions.weightToVolume(this.preferred_product_information, initAmount, oldVal, newVal, [cuom])
                    // / this.recipe_portion
                );

                console.log('recipe_amount_uo_weightt_to_volume newServingAmount', newServingAmount);

                // if (cuom.unit_type !== newVal) {
                // let sc = cuom.weight / cuom.unit_amount;
                // newServingAmount = newServingAmount * sc;
                // }
                // console.log('recipe_amount_uo_weightt_to_volume newServingAmount', newServingAmount, sc);
            }
            if (oldUomType === 'Volume' && newUomType === 'Weight' && this.cuoms) {
                // if (newVal === cuom.weight_units) {
                //     newServingAmount = this.recipe_amount / this.recipe_portion;
                // } else {
                newServingAmount = (this.$conversions.volumeToWeight(this.preferred_product_information, initAmount, oldVal, newVal, [cuom])
                    // / this.recipe_portion
                );
                // newServingAmount = newServingAmount * cuom.unit_amount;
                // }
                // newServingAmount = newServingAmount / sc;
                // newServingAmount = newServingAmount * cuom.unit_amount;
                // console.log('serving_amount_uom_weight volume to weight newServingAmount 3', newServingAmount);
                // console.log('serving_amount_uom_weight volume to weight sc', sc);
                // let smo = this.serving_amount * sc;
                // console.log('serving_amount_uom_weight sc', sc);
                // console.log('serving_amount_uom_weight volume to weight smo', smo);
                // console.log('serving_amount_uom_weight smo', smo);
            }
            if (oldUomType === 'Volume' && newUomType === oldUomType && this.cuoms) {
                console.log('serving_amount_uom_weight volume to volume', this.serving_amount, oldVal, newVal, this.cuoms);
                newServingAmount = this.$conversions.volume(this.serving_amount, oldVal, newVal);
            }

            if (newUomType === 'Unit' && oldUomType === 'Unit') {
                newServingAmount = initAmount;
            }

            if (newUomType === 'Unit' && oldUomType === 'Weight') {

                if (oldVal != cuom.weight_units) {
                    initAmount = this.$conversions.weight(initAmount, oldVal, cuom.weight_units);
                }
                newServingAmount = initAmount / (cuom.weight / cuom.unit_amount);
                console.log('conversion unit unit to weight', newServingAmount);
            }

            if (oldUomType === 'Unit' && newUomType === 'Weight') {
                newServingAmount = initAmount * (cuom.weight / cuom.unit_amount);
                if (newVal != cuom.weight_units) {
                    newServingAmount = this.$conversions.weight(newServingAmount, cuom.weight_units, newVal);
                }
                console.log('conversion unit weight to unit', newServingAmount);
            }

            this.serving_amount = this.convertToFix(newServingAmount);


            if (this.isConvertOrNot(this.serving_amount_fractions)) {
                this.serving_amount_fractions = this.decimalToFraction(this.convertToFix(this.serving_amount));
            } else {
                this.serving_amount_fractions = this.convertToFix(this.serving_amount);
            }
            // this.serving_amount = this.convertToFix(newServingAmount);
            this.handleChangeComponentUpdate(this.component_scale);
            this.getRecipeIngredientDataOnChange();
            // this.getRecipeIngredientDataOnChange();
        }
    },
    updated:
        function () {

        }

}
</script>

<style scoped>
.w-18-input {
    width: 90px;
}

.key-icon {
    transform: rotate(45deg);
}
</style>
